/**
 * @class
 * @description class being used for each single address
 * @param {Companies} args.parent
 * @param {Node} args.element the outer element of this crop
 * @param {Object} args.data the JSON data of this crop
 * @param {Object} args.user the JSON user data
 * @param {Object} args.translations text translations object
 */
export default class Company {
  constructor(args) {
    this.parent = args.parent;
    this.element = args.element;
    this.data = args.data;
    this.user = args.user;
    this.translations = args.translations;

    this.render();
  }

  render() {
    this.element.classList.add('item');
    this.element.innerHTML = this.template;
  }

  get template() {
    return `
      <div class="name">
        ${this.data.name}
      </div>
      <div class="vas">
        <span class="vas-banderole">
          ${this.translations.valueAddedSteps[this.data.global_value_added_step_id]}
        </span>
      </div>
      <ul class="address no-bullet no-margin no-padding">
        <li class="street">
          ${this.data.street}
        </li>
        <li class="city">
          ${this.data.zip} ${this.data.city}
        </li>
        <li class="country">
          <img class="flag-icon" src="/projects/application/dist/images/icons/flags/4x3/${this.data.country_short.toLowerCase()}.svg" alt="">
          <span>${this.data.country_name}</span>
        </li>
      </ul>
    `;
  }
}